export const minutesToTime = (value: number) => {
  return `${`${value}`.padStart(2, '0')}:00`;
};

export const secondsToTime = (value: number) => {
  const minuts = Math.floor(value / 60);
  const seconds = value - minuts * 60;
  return `${`${minuts}`.padStart(2, '0')}:${`${seconds}`.padStart(2, '0')}`;
};
